<template>
    <div class="call-container">
        <div class="loading-mask"
             v-loading="ui.isLoadingHistory"
             element-loading-text="拼命加载中"
             element-loading-spinner="el-icon-loading"
             element-loading-background="rgba(0, 0, 0, 0.8)"
             v-if="ui.isLoadingHistory" />
        <LeftMenu :show="ui.showLeftMenu" :typing="ui.typing"
                  :model="model === 'knowledge' ? 'knowledge' : 'commonMode'"
                  :historyMap="historyMap"
                  @selectNormal="deselectKnowledge"
                  @selectKnowledge="selectKnowledge"
                  @newChat="newChat"/>
        <div class="right-content">
            <div class="loading-mask" v-loading="ui.isLoadingChat"
                 element-loading-text="拼命加载中"
                 element-loading-spinner="el-icon-loading"
                 element-loading-background="rgba(0, 0, 0, 0.8)" v-if="ui.isLoadingChat" />
            <template v-if="model === 'knowledge'"><!-- 知识库对话 -->
                <keep-alive>
                    <div v-show="!currentKnowledge" class="knowledge-flex-wrapper knowledge-flex-list-wrapper">
                        <MsgWelcome v-model="WELCOME_KNOWLEDGE" :chat="currentChat" />
                        <KnowledgeList @setKnowledgeData="newKnowledgeChat" @setLoading="setIsLoadingHistory"/>
                        <CopyrightBar />
                    </div>
                </keep-alive>
                <div v-if="currentKnowledge" class="knowledge-flex-wrapper">
                    <div class="knowledge-flex-wrapper-top">
                        <el-link type="primary" :underline="false" @click="selectKnowledge">
                            <img src="@/theme/images/knowledge/icon-arrow-back.svg">
                            <span>返回知识库</span>
                        </el-link>
                        &nbsp;&nbsp;&nbsp;
                        <span class="iconfile" :class="getFileIcon(currentKnowledge.knowledgeName)"></span>
                        &nbsp;
                        {{currentKnowledge.knowledgeName}}
                    </div>
                    <div class="knowledge-flex-wrapper-main">
                        <div class="knowledge-flex-wrapper-left">
                            <div class="msg-box-flex-wrapper">
                                <MsgBoxScroll>
                                    <template v-for="(msg, index) in currentChat.messages">
                                        <MsgUserAsk v-if="msg.role === 'user'" :key="index" :ref="`msg${index}`" :data="msg" @askAgain="prompt = $event" />
                                        <MsgChatRespondThink v-else-if="msg.role === 'think'" :key="index" :ref="`msg${index}`" :data="msg" @thinkSocketFinish="thinkSocketFinish" />
                                        <MsgChatRespond v-else-if="msg.role === 'assistant'" :key="index" :ref="`msg${index}`"
                                                        :currentKnowledge="currentKnowledge"
                                                        :showSpeek="false"
                                                        :askData="currentChat.messages[index-1]" :data="msg"
                                                        :index="index"/>
                                        <div v-else :key="index">{{msg.content}}</div>
                                    </template>
                                </MsgBoxScroll>
                            </div>
                            <div class="input-box-flex-wrapper">
                                <div class="input-placeholder"></div>
                                <gpt-chatbox :class="[(ui.typing ? 'typing' : '')]" v-if="modelList.length" v-loading="ui.isSocketReconnecting" element-loading-text="会话连接中..."
                                    :modelList="modelListKnowledge" :input.sync="prompt" :model.sync="model" :typing="ui.typing" :simpleChatBox="true"
                                    @commonAsk="commonAsk" @knowledgeAsk="knowledgeAsk" @thinkAsk="thinkAsk" @inputAsk="inputAsk" @askAnswer="askAnswer"
                                    @askAnswerLoading="askAnswerLoading" @askAnswerFinish="askAnswerFinish" @trafficAsk="trafficAsk">
                                </gpt-chatbox>
                                <div class="input-placeholder"></div>
                            </div>
                            <div v-show="!showKnowledgeFile" class="knowledge-file__open" @click="showKnowledgeFile = true">
                                <div class="knowledge-file__open-img"></div>
                            </div>
                        </div>
                        <div v-show="showKnowledgeFile" class="knowledge-flex-wrapper-right">
                            <div class="viewer-editor">
                                <gpt-viewer-pdf v-if="currentKnowledge.knowledgeType === 1" :url="currentKnowledge.url || currentKnowledge.knowledgeUrl" />
                                <qaTable v-else :documentInfo="currentKnowledge" :positionAbsolute="true"></qaTable>
                            </div>
                            <div v-show="showKnowledgeFile" class="knowledge-file__close" @click="showKnowledgeFile = false">
                                <div class="knowledge-file__close-img"></div>
                            </div>
                        </div>
                    </div>
                    <CopyrightBar />
                </div>
            </template>
            <template v-else> <!-- 常规对话 -->
                <div class="msg-box-flex-wrapper">
                    <MsgBoxScroll>
                        <MsgWelcome v-model="WELCOME_COMMON" :chat="currentChat" />
                        <template v-for="(msg, index) in currentChat.messages">
                            <MsgUserAsk v-if="msg.role === 'user'" :key="index" :ref="`msg${index}`" :data="msg" @askAgain="prompt = $event" />
                            <MsgChatRespondThink v-else-if="msg.role === 'think'" :key="index" :ref="`msg${index}`" :data="msg" @thinkSocketFinish="thinkSocketFinish" />
                            <MsgChatRespond v-else-if="msg.role === 'assistant'" :key="index" :ref="`msg${index}`" :askData="currentChat.messages[index-1]"
                                            :data="msg" :index="index"/>
                            <div v-else :key="index">{{msg.content}}</div>
                        </template>
                        <MsgWelcomePrompt v-if="currentChat && currentChat.messages && currentChat.messages.length === 0" v-model="WELCOME_COMMON" @fillText="model = $event.model; prompt = $event.prompt;" />
                    </MsgBoxScroll>
                </div>
                <div class="input-box-flex-wrapper">
                    <div class="input-placeholder"></div>
                    <gpt-chatbox :class="[(ui.typing ? 'typing' : '')]" v-if="modelList.length" v-loading="ui.isSocketReconnecting" element-loading-text="会话连接中..."
                        :modelList="modelList" :input.sync="prompt" :model.sync="model" :typing="ui.typing"
                        :sessionId="currentChat && currentChat.sessionId" @assistantAsk="assistantAsk"
                        @commonAsk="commonAsk" @thinkAsk="thinkAsk" @inputAsk="inputAsk" @askAnswer="askAnswer"
                        @askAnswerLoading="askAnswerLoading" @askAnswerFinish="askAnswerFinish" @trafficAsk="trafficAsk"
                        @reconnectSocket="handleReconnectSocket">
                    </gpt-chatbox>
                    <div class="input-placeholder"></div>
                </div>
                    <CopyrightBar />
            </template>
        </div>

        <PictureDemo v-if="pictureDemoShow" @back="pictureDemoShow = false"></PictureDemo>
        <gpt-shortcuts v-if="model !== 'knowledge'"
                       @assistantChat="assistantChat"
                       @changeModelSetting="changeModelSetting"
                       @toPictureDemo="toPictureDemo"/>
    </div>
</template>

<script>
import historyAPI from '@/api/history.api.js';

import KnowledgeChatMixin from '@/app/mixins/KnowledgeChatMixin.js';
import CommonAskMixin from '@/app/mixins/CommonAskMixin.js';
import KnowledgeAskMixin from '@/app/mixins/KnowledgeAskMixin.js';
import ThinkAskMixin from '@/app/mixins/ThinkAskMixin.js';
import TrafficAskMixin from '@/app/mixins/TrafficAskMixin.js';
import ChatSocketMixin from '@/app/mixins/ChatSocketMixin.js';
import SseMixin from '@/app/mixins/SseMixin.js';
import AssistantChatMixin from '@/app/mixins/AssistantChatMixin.js';

import { WELCOME_COMMON, WELCOME_KNOWLEDGE } from '@/app/constant/WELCOME.js';

import { timeToString } from '@/utils/time.js';

import KnowledgeList from '@/app/components/ui/KnowledgeList.vue';
import CopyrightBar from '@/app/components/ui/CopyrightBar.vue';
import LeftMenu from '@/app/components/ui/LeftMenu.vue';
import MsgBoxScroll from '@/app/components/ui/MsgBoxScroll.vue';
import MsgWelcome from '@/app/components/chatMsg/MsgWelcome.vue';
import MsgWelcomePrompt from '@/app/components/chatMsg/MsgWelcomePrompt.vue';
import MsgUserAsk from '@/app/components/chatMsg/MsgUserAsk.vue';
import MsgChatRespond from '@/app/components/chatMsg/MsgChatRespond.vue';
import MsgChatRespondThink from '@/app/components/chatMsg/MsgChatRespondThink.vue';
import MsgKnowledgeFileSelect from '@/app/components/chatMsg/MsgKnowledgeFileSelect.vue';
import PictureDemo from '@/app/views/picture-demo/picture-demo.vue';

import qaTable from '@/app/components/ui/_MemFrontendPage/qa-table';
export default {
    name: 'call',
    components: {
        KnowledgeList,
        CopyrightBar,
        LeftMenu,
        MsgBoxScroll,
        MsgWelcome,
        MsgWelcomePrompt,
        MsgUserAsk,
        MsgChatRespond,
        MsgChatRespondThink,
        MsgKnowledgeFileSelect,
        qaTable,
        PictureDemo
    },
    mixins: [KnowledgeChatMixin, CommonAskMixin, AssistantChatMixin, SseMixin, KnowledgeAskMixin, ThinkAskMixin, TrafficAskMixin, ChatSocketMixin],
    data () {
        return {
            pictureDemoShow: false,
            prompt: '', // 当前输入内容
            model: null, // 当前使用哪个模型
            ui: {
                isSocketReconnecting: false, // 是否正在连接socket
                isLoadingHistory: true, // 正在加载总历史列表
                isLoadingChat: false, // 正在加载当前聊天的历史记录
                typing: false, // 是否在输入中
                recording: false, // 是否在录音中
                showLeftMenu: true
            },
            currentChat: {
                title: '',
                sessionId: '',
                messages: [],
                updateTime: 0
            },
            currentSessionId: '',
            historyMap: {},
            mdTempStr: '', // 多模态输出临时字符串
            WELCOME_COMMON, // 欢迎信息
            WELCOME_KNOWLEDGE, // 知识库欢迎信息
            modelSettings: {
                maxLength: 1024,
                contextLimit: 3,
                temperature: 0.6
            },
            isAutoReconnect: true
        };
    },
    provide () {
        return {
            deleteChat: this.deleteChat,
            loadChat: this.loadChat,
            editTitle: this.editTitle,
            currentSessionId: () => this.currentSessionId,
            stopGenerating: this.stopGenerating,
            starSession: this.starSession
        };
    },
    computed: {
        useLLM () {
            return this.$store.state.appSettings.useLLM;
        },
        modelList () {
            return this.$store.state.appSettings.modelList;
        },
        allSession () {
            let all = [];
            for (const sessionId in this.historyMap) {
                const session = this.historyMap[sessionId];
                if (!session['temporary']) all.push(session);
            }
            all.sort((a, b) => b.createdTimeStamp - a.createdTimeStamp);
            return all;
        }
    },
    watch: {
        'model': function (val) {
            this.changeModelSetting();

            // 选择了知识库问答
            if (val === 'knowledge' && this.currentKnowledge === null) {
                this.selectKnowledge();
            }
        }
    },
    async mounted () {
        await this.$store.dispatch('appSettings/initModelList');

        await this.loadHistory(); // 加载历史对话
        const currentSessionId = localStorage.getItem('currentSessionId'); // 最后使用的会话id
        if (currentSessionId && this.historyMap[currentSessionId]) {
            this.loadChat(currentSessionId); // 加载会话
        } else {
            this.newChat(); // 新建会话
        }
    },
    methods: {
        /**
        * 加载总历史列表
        */
        async loadHistory () {
            this.ui.isLoadingHistory = true;
            let result = await historyAPI.getHistoryList();

            result.data.forEach(element => {
                element['createdTimeStamp'] = Date.parse(element.createTime);
                this.$set(this.historyMap, element.sessionId, element);
            });
            this.ui.isLoadingHistory = false;
        },

        /**
         * 截取文件URL，去掉前面的域名
         */
        parseFileUrl (url) {
            if (url && url.indexOf('/llm/') >= 0) {
                url = '/llm-files/' + url.substring(url.indexOf('/llm/') + 5);
            }
            return url;
        },

        /**
        * 创建新聊天
        */
        async newChat (model) {
            if (this.ui.typing) return;
            if (this.ui.isLoadingChat) return;
            this.ui.isLoadingChat = true;
            if (model) { // 设置当前调用模型
                this.model = model;
            } else {
                this.model = (this.modelList && this.modelList.length ? this.modelList[0].value : 'commonMode');
            }
            let result = await historyAPI.getNewSessionId();
            // 创建时先不保存数据
            this.currentSessionId = result.data;
            this.currentChat = {
                collected: 0,
                title: '',
                sessionId: result.data,
                messages: [],
                createdTimeStamp: Date.now()
            };
            // 保存
            localStorage.setItem('currentSessionId', this.currentSessionId);
            await this.saveChat('');

            this.ui.isLoadingChat = false;
            this.$bus.$emit('newChat:reflash');
        },

        /**
        * 保存会话
        */
        async saveChat (title) {
            let payload = {
                collected: 0,
                modelCode: '444',
                createTime: timeToString(Date.now()),
                createdTimeStamp: Date.now(),
                sessionId: this.currentSessionId,
                title: title.toString()
            };
            if (this.currentKnowledge) { // 知识库对话
                payload.knowledgeId = this.currentKnowledge.knowledgeId;
                payload.knowledgeName = this.currentKnowledge.knowledgeName;
            }
            this.$set(this.historyMap, this.currentSessionId, payload);
            await historyAPI.saveSession(payload);
        },

        /**
        * 保存会话
        */
        async saveContext (isInvalid) {
            let askObj = this.currentChat.messages[this.currentChat.messages.length - 2];
            let answerObj = this.currentChat.messages[this.currentChat.messages.length - 1];
            answerObj['askContent'] = askObj.content;
            console.log('answerObj', answerObj);
            let extInfo = JSON.stringify({ askObj, answerObj });
            let question = askObj.notShowContent ? askObj.notShowContent + `Question:${askObj.content}` : askObj.content;
            let payload = {
                'answer': answerObj.content,
                'questionTime': timeToString(askObj.questionTime || Date.now()), // 提问时间
                'createTime': timeToString(Date.now()), // 回答时间
                'externalInfo': extInfo,
                'isInvalidAnswer': isInvalid ? 1 : 0,
                'likeOrNot': 0,
                'question': question,
                'sessionId': this.currentSessionId,
                'useModel': this.useLLM
            };
            let result = await historyAPI.saveOneContext(payload);
            answerObj['questionId'] = result.data;
        },

        /**
        * 删除当前会话
        */
        async deleteChat (sessionId) {
            if (this.currentChat.sessionId === sessionId) {
                let current = this.currentChat;
                let next = null;
                let idx = this.allSession.findIndex((item) => {
                    return item.sessionId === sessionId;
                });
                for (let i = idx + 1; i < this.allSession.length; i++) {
                    let item = this.allSession[i];
                    if (current.sessionId === item.sessionId) {
                        continue;
                    } else if (current.knowledgeId && item.knowledgeId) {
                        next = item;
                        break;
                    } else if (!current.knowledgeId && !item.knowledgeId) {
                        next = item;
                        break;
                    }
                }
                if (!next) {
                    for (let i = 0; i < this.allSession.length; i++) {
                        let item = this.allSession[i];
                        if (current.sessionId === item.sessionId) {
                            continue;
                        } else if (current.knowledgeId && item.knowledgeId) {
                            next = item;
                            break;
                        } else if (!current.knowledgeId && !item.knowledgeId) {
                            next = item;
                            break;
                        }
                    }
                }
                if (!next) {
                    this.newChat(true);
                } else {
                    this.loadChat(next.sessionId);
                }
            }
            this.$delete(this.historyMap, sessionId);
            let payload = { sessionId };
            await historyAPI.deleteSession(payload);
        },

        /**
        * 加载会话
        */
        async loadChat (sessionId) {
            if (this.ui.typing) return;
            if (!this.historyMap[sessionId]) return;
            if (this.ui.isLoadingChat) return;
            this.ui.isLoadingChat = true;
            localStorage.setItem('currentSessionId', sessionId);
            this.currentSessionId = sessionId;
            Object.assign(this.currentChat, this.historyMap[sessionId]);
            this.currentChat.messages = [];
            let result = await historyAPI.getChatHistory(sessionId);

            for (const context of result.data) {
                const { askObj, answerObj } = JSON.parse(context.externalInfo);
                answerObj['feedback'] = context.likeOrNot;
                answerObj['questionId'] = context.questionId;
                answerObj['finished'] = true;
                this.currentChat.messages.unshift(answerObj);
                this.currentChat.messages.unshift(askObj);
            }
            // 如果是知识库问答则加载相关知识库
            let session = this.historyMap[sessionId];
            this.currentKnowledge = null;
            if (session && session.knowledgeId) {
                await this.getKnowledgeData(session.knowledgeId);
            } else {
                this.model = 'commonMode'; // 切换到常规对话
            }
            this.$nextTick(() => {
                this.ui.isLoadingChat = false;
            });
            this.$bus.$emit('newChat:reflash');
        },

        /**
        * 修改会话标题
        */
        async editTitle (sessionId, title) {
            if (!this.historyMap[sessionId]) return;
            let payload = { sessionId, title };
            await historyAPI.editTitle(payload);
            this.historyMap[sessionId].title = title;
        },

        /**
        * 星级会话
        */
        async starSession (sessionId, collected) {
            this.historyMap[sessionId].collected = collected;
            let payload = { sessionId, collected };
            await historyAPI.starSession(payload);
        },

        /**
        * 停止生成
        */
        async stopGenerating () {
            if (!this.ui.typing) return;
            let payload = { sessionId: this.currentSessionId };
            await historyAPI.stopAnswer(payload);

            this.closeSocket();
            // 停止sse接口返回
            this.sseController && this.sseController.abort();

            let last = this.currentChat.messages[this.currentChat.messages.length - 1];
            // 打字完成
            this.ui.typing = false;
            if (last && last.role === 'assistant') this.$set(last, 'finished', true);
            this.saveContext(true);
        },

        /**
        * 清空会话
        */
        clearChat () {
            this.currentChat = {
                title: null,
                prompt: '',
                messages: []
            };
        },
        /**
        * 改变模型参数
        */
        changeModelSetting () {
            let model = this.$store.state.appSettings.modelList.find(item => item.value === this.model);
            if (model && model.modelSettings) {
                this.modelSettings = model.modelSettings;
            } else {
                this.modelSettings = {
                    maxLength: 1024,
                    contextLimit: 3,
                    temperature: 0
                };
            }
        },
        setIsLoadingHistory (state) {
            this.ui.isLoadingHistory = state;
        },
        // 打开视觉模型
        toPictureDemo () {
            this.pictureDemoShow = true;
        }
    }
};
</script>
<style scoped lang="scss">
.loading-mask {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 120;
    backdrop-filter: blur(20px);
    background-color: rgba(41, 105, 255, 0.2);
}

.call-container {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-flow: row nowrap;
    // background: linear-gradient(137deg, #fff 0%, rgb(219, 230, 255) 100%);

    .right-content {
        position: relative;
        width: 100%;
        height: 100%;
        flex: 1 1 auto;
        display: flex;
        flex-flow: column nowrap;
        align-items: center;
        justify-content: space-between;
        background: var(--page-bg-img);
        background-size: cover;
        overflow: hidden;

        .knowledge-flex-wrapper {
            position: relative;
            width: 100%;
            height: 100%;
            flex: 1 1 auto;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }
        .knowledge-flex-list-wrapper {
            max-width: 1000px;
        }
        .knowledge-flex-wrapper-top {
            position: relative;
            width: 100%;
            height: 64px;
            border-bottom: 1px solid var( --shortcuts-border);
            background-color: var(--msg-welcome-prompt-bg);
            flex: 1 1 auto;
            display: flex;
            align-items: center;
            padding: 0 1em;
            ::v-deep{
                .el-link--inner{
                    height: 24px;
                    display: flex;
                    align-items: center;
                    >img{
                        margin-right: 8px;
                    }
                    >span{
                        color: var(--ai-model-classification-font);
                    }
                }
            }
            .iconfile{
                font-size: 24px;
            }
        }
        .knowledge-flex-wrapper-main {
            position: relative;
            width: 100%;
            height: calc(100% - 64px);
            flex: 1 1 auto;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        .knowledge-flex-wrapper-left,
        .knowledge-flex-wrapper-right {
            position: relative;
            width: 50%;
            height: 100%;
            flex: 1 1 auto;
            display: flex;
            flex-flow: column nowrap;
            align-items: center;
            justify-content: space-between;
        }

        .knowledge-flex-wrapper-right {
            border-left: 1px solid var(--shortcuts-border);
        }

        .msg-box-flex-wrapper {
            flex: 1 1 auto;
            width: 100%;
            overflow: hidden;
        }

        .input-box-flex-wrapper {
            flex: 0 0 auto;
            width: 100%;
            max-width: 1000px;
            display: flex;
            flex-flow: row nowrap;
            justify-content: center;

            .input-placeholder {
                flex: 0 0 58px;
            }

            .gpt-chatbox {
                &.typing {
                    pointer-events: none;
                    opacity: 0.6;
                }
            }
        }
    }

    .viewer-editor {
        background: var(--knowledge-right-bg);
        position: relative;
        width: 100%;
        height: 100%;
    }

    .knowledge-file__open {
        position: absolute;
        right:0;
        top: 45%;
        width: 20px;
        height: 80px;
        right: 0;
        z-index: 10;
        cursor: pointer;

        .knowledge-file__open-img {
            width: 20px;
            height: 80px;
            background-repeat: no-repeat;
            background-size: contain;
            background-image: var(--shortcuts-open-img);
        }
    }
    .knowledge-file__close {
        position: absolute;
        left:0;
        top: 45%;
        width: 20px;
        height: 80px;
        right: 0;
        z-index: 10;
        cursor: pointer;

        .knowledge-file__close-img {
            width: 100%;
            height: 100%;
            background: var(--right-close-img);
            transform: translateX(-20px);
        }
    }
    .el-loading-mask {
        z-index: 99;
    }
}
</style>
